import React from 'react';
import cx from 'classnames';
import './Container.scss';

const Container = React.forwardRef(({component: Component = 'div', className, children, ...props}, ref) => {
  return (
    <Component className={cx('container', className)} {...props} ref={ref}>
      {children}
    </Component>
  );
});

Container.displayName = 'Container';

export default Container;
